import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const { completeGoogleSession } = useAuth();
    const navigate = useNavigate();
    const hasProcessed = useRef(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || '';
        const match = hash.match(/session_id=([^&]+)/);
        const sessionId = match ? decodeURIComponent(match[1]) : null;

        if (!sessionId) {
            navigate('/login', { replace: true });
            return;
        }

        (async () => {
            try {
                const user = await completeGoogleSession(sessionId);
                // Land back on whatever path the user originally tried to reach.
                const target = window.location.pathname && window.location.pathname !== '/' ? window.location.pathname : '/dashboard';
                window.history.replaceState({}, document.title, target);
                navigate(target, { replace: true, state: { user } });
            } catch (e) {
                setError(e?.response?.data?.detail || 'Login failed. Try again.');
                setTimeout(() => navigate('/login', { replace: true }), 1500);
            }
        })();
    }, [completeGoogleSession, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[var(--ns-bg)]" data-testid="auth-callback">
            <div className="text-center">
                <div className="mx-auto w-10 h-10 rounded-full border-2 border-[var(--ns-border)] border-t-[var(--ns-clay)] animate-spin" />
                <p className="mt-4 text-[var(--ns-text2)]">Finishing sign in…</p>
                {error && <p className="mt-2 text-sm text-[var(--ns-clayHover)]">{error}</p>}
            </div>
        </div>
    );
}
